import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import IconToast from '../NewToast';

interface TodoSaveErrorToastProps {
  intl: { formatMessage: (descriptor: { id: string }) => string };
}

/**
 * The one place a failed todo write is reported.
 *
 * This used to live in TodoList's componentDidUpdate, so the toast came from
 * whichever TodoList instances happened to be mounted: two when the top bar's
 * hidden list and a drawer's list were both up, none once the drawers stopped
 * keeping their lists mounted and the adviser closed the drawer before the
 * request returned. Mounted once at the app root, it fires exactly once per
 * failed write, whether or not any ToDo drawer is open.
 *
 * Same edge TodoList used: the todoList duck's `isSubmitting` going true→false
 * with an `error` set (a transport error, or a 200 carrying success: false).
 */
const TodoSaveErrorToast: React.FC<TodoSaveErrorToastProps> = ({ intl }) => {
  const isSubmitting = useSelector((state: any) => state.todoList.isSubmitting);
  const error = useSelector((state: any) => state.todoList.error);
  const wasSubmittingRef = useRef(isSubmitting);

  useEffect(() => {
    if (wasSubmittingRef.current && !isSubmitting && error) {
      toast.info(IconToast('error', intl.formatMessage({ id: 'todo-err-msg' })), { className: 'new-toast' });
    }
    wasSubmittingRef.current = isSubmitting;
  }, [isSubmitting, error, intl]);

  return null;
};

export default injectIntl(TodoSaveErrorToast);
